// Converts YYYY-MM-DD to DD-MM-YYYY for display only.
// Keep YYYY-MM-DD for API, database, date inputs, sorting, and CSV.
// Do not use this for dates that already have a custom format like "Jan 1" or "Aug 26".
export function formatDdMmYyyy(iso: string): string {
  const [y, m, d] = iso.split('-');
  return `${d}-${m}-${y}`;
}

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

// For full ISO timestamps (createdAt/updatedAt-style values with a time component, not a plain
// YYYY-MM-DD date) — converts to the viewer's local timezone and formats the date-only portion
// as DD-MM-YYYY, matching formatDdMmYyyy's display convention. Use this instead of
// `new Date(iso).toLocaleDateString()` anywhere a timestamp's date needs to display without its
// time (e.g. Escalation's Actual Resolution Date).
export function formatDdMmYyyyFromTimestamp(iso: string): string {
  const d = new Date(iso);
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
}

// Same as formatDdMmYyyyFromTimestamp, plus a local HH:mm time — for timestamps where the time
// of day is part of what's being communicated (log entries, comments, audit trail rows). Use
// this instead of `new Date(iso).toLocaleString()`, which renders in a locale-dependent,
// inconsistent order (e.g. MM/DD/YYYY) rather than the app's DD-MM-YYYY convention.
export function formatDdMmYyyyHm(iso: string): string {
  const d = new Date(iso);
  return `${formatDdMmYyyyFromTimestamp(iso)}, ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
